module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Home Sweet")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Professional jealousy, that’s what it is,” Dave joked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I beg your pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My uncle turned up the volume on the television, that we might better hear the news. It was all over the local affiliates, which was funny for an investigation that was ostensibly hush-hush. A skinny blond anchorwoman repeated the Marshalls’ vow to “get to the bottom of things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Disdain, perhaps—but never jealousy,” I corrected. “It’s revolting, the way they capitalize on things like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Revolting?” Lulu tapped me with her hip as she squeezed by, carrying a tray of nachos. She set the heaping snacks on the coffee table and went back towards the kitchen. “That’s a strong word for it. They’re some kind of scientists, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, and I’m Big Bird.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Lu took a bite of a chip loaded with beans and jalapeños, chewed it, and swallowed without flinching. “I don’t know. You might be. I’m surprised at you, really. I’d think you might be warm to the idea of having someone else in town for the cra")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("zies to talk at. For that matter, it might do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" good to have someone to talk at.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Speaking of being talked at, it happened again today.” I reached past her to pick up a handful of chips that seemed mostly devoid of hot peppers, and I took a nibble. I winced, even though only the barest trace of pepper juice hit my tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I might have said more about it—I might have told them about Gary and the tooth—but Dave flashed me a look that made me think better of it. He rose and headed towards the kitchen, and I followed him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He opened the refrigerator door and stood inside the patch of dim light and cold air. “Something else happened again today too,” he said quietly, and not happily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dare I ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have to?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wasn’t sure how to respond. It was one of those moments where I didn’t know what I’d done to perturb him, and I didn’t want to start confessing to things until he gave me a hint. I cycled through a mental checklist of things he might scold me for, but I couldn’t come up with anything he may have caught me doing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked over the fridge door, checking to make sure Lu was still in the living room. We could both see her feet, propped up on the coffee table beside the plate of chips. I watched Dave decide that the coast was as clear as it was going to get.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Someone called for you,” he said. “It was some guy who claimed he was a friend of Harry’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh. What did he want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To talk to you, I imagine. It’s the third time this month the same guy has called. Is there anything you feel like you ought to tell me, kid?” He leaned on the door, eyes still holding the partial scene in the living room.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” I said in perfect truthfulness. I most certainly did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" want to tell him that I’d warned Malachi to quit calling my cell phone, and that it now appeared the bastard was obeying the letter of the command, if not the spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eden, are you in some kind of trouble? Because if you are, you can tell me, and if you want, I’ll keep it quiet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dave, I appreciate the offer, but I am not in any trouble whatsoever—not to the best of my knowledge.” Again, I answered with pure honesty. “I’ll call down to St. Augustine tomorrow and ask Harry what’s up. I’m sure it’s no big deal. If something was wrong I’m sure my mystery caller would have left a message.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This too was true, though I also planned to give Harry full permission to beat Malachi senseless the next time he thought about phoning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are you two doing in there?” Lu hollered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s the sour cream?” I shouted back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re out. But there’s some salsa behind the milk. Grab that and some napkins—and come back in here. Let’s start this movie, already.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I reached around Dave to seize the salsa and the opportunity to flee, before he could interrogate me further.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So far as anyone officially knew, my half-brother and cousin Malachi was dead—murdered by the crazy old man who had lived at the clapboard house in the swamp. Not much in the way of remains had survived the fire, but I’d insisted with great fervor and earnestness that he’d been there in the hopes that it would keep the cops from trying to locate him elsewhere. In retrospect, I’m not entirely sure why I went to such lengths to protect him, but that’s how family works sometimes. Even when they don’t deserve it, you cover their asses.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe I should have told Lu and Dave what really happened down in Florida, but I hadn’t, and I couldn’t imagine a situation where I could bring it up. I didn’t want to have to defend myself to them—and I would certainly have to, if I came clean—until I had a better excuse than “It sounded like a good idea at the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Malachi wasn’t exactly making it easy for me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d called my cell phone every week until I finally switched it out for another model with a new number. The new number hadn’t stopped him though. I don’t know how he got it, but he did, and he called it like clockwork. About one time out of every four I’d answer, and we’d verbally hopscotch through an awkward, meaningless conversation that served no purpose other than to make us both uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d sometimes hinted that he wanted to come up here, but I kept telling him not to.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let things die down,” I’d tried to tell him. “Give it a year or two. Then we’ll meet up someplace in Georgia and do lunch, if that’s what you want.” But he always wanted more than lunch. He wanted a family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I bet he was driving Harry nuts. But that’s what the old guy gets for taking Malachi down there to St. Augustine. If Harry’d had any sense, he would have left my brother for the cops; instead, he let me talk him into taking Malachi to Florida and hiding him in the monastery there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that night I tried to put them both out of my head, because I had nachos in the living room, Lu and Dave on the sofa, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Young Frankenstein")]), _vm._v(" in the DVD player. Everything else could wait.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The next day, Lu and Dave drove down to Athens, Georgia, to catch a concert. I ordered them to make a romantic weekend of it, but they were way ahead of me: Hotel reservations and a room service menu had already been secured. I was a little surprised by my relief at learning that they’d be gone for so long; or perhaps I was only glad to know that they were far enough away that I could make a phone call in peace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The call itself began easily enough. I dialed Harry’s cell and wondered idly if his ring-tone was set to any particular music.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Harold here,” he answered, and I was glad. I’d half expected Malachi to pick up, just because I didn’t want to talk to him and the universe occasionally allies against me that way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And Eden here,” I responded. “How goes it down there, old man?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He laughed a little and cleared his throat. “Oh, more of the same. But what brings you to the phone? Malachi says he can’t get you on the line to save his life these days.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m glad to hear he’s noticed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not taking the hint, huh? I thought you might be avoiding him. I told him to give you some breathing room, but he’s so damn eager to make friends, he won’t listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s started calling me at home, Harry. You’ve got to make him stop. When it’s just the phone I’ve got in my purse, I can ignore him till the cows come home; but if he keeps looking for me here, I’m going to have a whole lot of elaborate lying to do. As it is, Dave already suspects something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What have you told him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("“Nothing, except what we agreed on. I’ve got my fingers crossed that he thinks I’m hiding a boyfriend, but I’m probably wrong and he’s half an idea closer to the truth. I don’t think he ever bought the story as we laid it out, not one hundred per")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("cent. Even if he doesn’t think I’m "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lying,")]), _vm._v(" he might suspect that I don’t know the whole story. When I logged on to the Internet here the other day, there were some links in the history folder that suggested one of them had been looking to dig up news stories about last year. It might’ve been Lu, but my money’s on Dave.”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Any particular reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, just a hunch. I think Lu already knows more than she lets on, but she’s happy with whatever fiction makes the most sense. Everything’s back to abnormal, and she doesn’t care. Dave’s curious, though. I think he feels left out of the loop.” Funny. I hadn’t realized that part until I said it out loud.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Makes sense,” Harry agreed. “Why don’t you fill him in a little? Throw him a bone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Which bone exactly would you have me throw him? The one about how my homicidal half-brother isn’t really dead—or the one about me hacking up my undead grandfather in self-defense? Hell, maybe we should clue him in on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" that hocus-pocus at the shack. That’d make a great dinner conversation, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eden…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I could explain how since that night I can see dead people so well I sometimes can’t tell them apart from the living, and, oh yes, by the way, did you notice I haven’t been sick since then? Haven’t had so much as a bruise or a paper cut? How am I supposed to explain all this to him when I’m not sure what happened myself?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh settle "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("down.")]), _vm._v(" You don’t have to tell him much, maybe just talk to him about it some—even if you’ve got to be vague. He almost lost his two favorite women, and he doesn’t know why or how. I can hardly blame the man for being curious.”")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess.” I shifted the phone to my other shoulder and sat down on the arm of the couch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s sweet, though. The way you want to protect him, when he thinks he’s protecting you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m a real sweet girl, or so they tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, nobody really. You might actually be the first.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grunted with amusement. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That,")]), _vm._v(" I believe. Hey, since I’ve got you on the phone, I don’t suppose you’ve heard about that nonsense at the battlefield, have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I groaned. “I live on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("top")]), _vm._v(" of a rock, Harry—not under one. How did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" hear about it? Surely it hasn’t made anything past the local news?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I couldn’t say. I didn’t hear about it on the news; I heard about it via the Marshalls. They’re up there right now, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If they aren’t, they will be soon. And that’s just what the battlefield needs—more ghost hunters. Damn Yankees ought to stay home and chase their own ghosts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those damn Yankees are from one of the Carolinas, I believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shook my head, as if he could hear it rattle. “And what, pray tell, is your interest in the Marshalls?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Purely professional, I assure you. They did some fascinating research into a case in England a few years back. Friends of a friend. You know how it is. They’re not so bad, once you get to know them. Dana’s a tad abrasive, but you’d really like Tripp if you gave him a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll take your word for it. They were on the news here last night, throwing slogans around. If I hear how they’re going to ‘get to the bottom of things’ one more time, I’m going to start screaming. They’re not going to get to the bottom of squat.”")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So why don’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you,")]), _vm._v(" then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’d walked right into that one, but I was prepared to walk right out of it, too. “Because I’m not interested in getting to the bottom of it. There’s probably nothing to get to the bottom "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of.")]), _vm._v(" It’s a battlefield, Harry. People died there. It’s haunted. End of dull and uncomplicated story.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a terrible liar,” he accused.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, I’m an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("excellent")]), _vm._v(" liar. You’re hearing what you want to hear. I’m done with ghosts. I’m tired of them. I see them plenty enough as it is; I’m not about to go looking for more. They’re like those crazy homeless people who hang out downtown—if you give them five seconds of attention once, they never leave you alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I doubt that’s a fair comparison.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It might be. What do you know, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Quite a lot that might surprise you,” he said. A very vacant pause followed, and I couldn’t tell if he was being dramatic or if he’d stopped to think.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The silence bothered me, so I filled it in. “I’m going to let the Marshalls take care of the battlefield. It’s not my problem. Hell, it’s probably not anybody’s problem. Some people saw some ghosts. Who cares?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The ghosts care, apparently. They seem to be going out of their way to try and communicate, but their success has been limited so far. It might be something important. In fact, I have to think that it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must")]), _vm._v(" be—if the reports are right, and the sightings are so consistent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Really, dear,” he went on, “you’re in such a unique position to assist them. It’s a shame you don’t want to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I bet the Marshalls don’t want any help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They might. I could make some phone calls.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dare.")]), _vm._v(" They’re probably fakes, anyway.”")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” he insisted with a suddenness that surprised me. “They’re not fakes. They’re not as gifted as they want to believe they are, and they’re publicity whores of the highest caliber, but they do get real results. That’s one reason I think you should see about contacting them, or offering to help their investigation. It might do you good to meet other people like yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you want to hook me up with a play-date? Honestly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He let slide another one of those pauses, and I almost interrupted him when he continued. “You know,” he said, “you’re not alone. There are other people who can see things and tell things that most people wouldn’t believe. You ought to find a few of them and make some friends; it isn’t that hard. The social circles are small, but they exist. I could give you a phone number or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I watch late-night TV every now and again. I’ve got access to all the 1-900 numbers I can stand, thanks.” I tried to sound flippant, but it came off too dry to be careless.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s no need to be catty. I’m not trying to hook you up with a psychic shrink; I’m trying to explain that there are people out there outside your immediate gene pool who might understand what it’s like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“To what end? I don’t need any pen pals, Harry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For your own well-being, or peace of mind. You’re entirely too isolated up there in Chattanooga. It’ll make you crazy, being your kind of different and having no one to share it with.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Crazy like Malachi?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I almost heard Harry’s eyes roll. “He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" an easy example, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the end, the phone call was pleasant, but less than productive. By the time we hung up, I was unconvinced that he’d put a stop to Malachi’s pestering—and he was unconvinced that I was uninterested in the battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We were both right to be suspicious.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  })]), _c('a', {
    attrs: {
      "id": "page44"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page44"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fba3c42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429939973_ch03.vue
// module id = 81
// module chunks = 0